import React from "react";
import { GoogleLogo } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const GoogleAuthButton = ({ role = "fan", label = "Continuer avec Google", testId = "google-auth-btn" }) => {
  const handleClick = () => {
    sessionStorage.setItem("xookmedia_google_role", role);
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={handleClick}
      className="w-full flex items-center justify-center gap-3 px-4 py-2.5 rounded-md border border-white/20 bg-white text-black font-bold text-sm hover:bg-zinc-100 transition-colors"
    >
      <GoogleLogo size={20} weight="bold" />
      {label}
    </button>
  );
};

export default GoogleAuthButton;
